/* eslint-env browser */

/**
 * Dark mode support
 */

(function (window, document) {

    function changeCommentsTheme(isDark) {
        var iframe = document.getElementById('comments-app-x-UCJNvM-1');
        var script = document.getElementById('comments-app-script');
        if (iframe) {
            if (iframe.src.includes('&dark=')) {
                iframe.src = iframe.src.replace(`&dark=${isDark ? 0 : 1}`, `&dark=${isDark ? 1 : 0}`);
            } else {
                iframe.src = iframe.src + `&dark=${isDark ? 1 : 0}`;
            }
        } else if (script) {
            script.setAttribute('data-dark', isDark ? '1' : '0');
        }
    }

    function changeTheme(isDark) {
        if (isDark) {
            if (!document.documentElement.classList.contains('dark-mode')) {
                document.documentElement.classList.add('dark-mode');
            }
        } else {
            if (document.documentElement.classList.contains('dark-mode')) {
                document.documentElement.classList.remove('dark-mode');
            }
        }
        changeCommentsTheme(isDark)
    }

    const currentTheme = localStorage.getItem('theme')

    $(window).on('load', function () {
        let toggleSwitch = document.querySelector('.theme-switch-wrapper .theme-switch input[type="checkbox"]');
        if (currentTheme === 'dark' || document.documentElement.classList.contains('dark-mode')) {
            changeTheme(true);
            toggleSwitch.checked = true;
        }
        toggleSwitch.addEventListener('change', (e) => {
            changeTheme(e.target.checked);
            localStorage.setItem('theme', e.target.checked ? 'dark' : 'light');
        }, false);
    });

})(window, document);
